import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Create context
const ActiveContext = createContext<any>(null);

// Custom hook to use the ActiveContext
export const useActive = () => useContext(ActiveContext);

// Provider component
export const ActiveProvider = ({ children }) => {
	const location = useLocation();
	const [active, setActive] = useState(() => {
		const savedActive = localStorage.getItem('active');
		return savedActive !== null ? parseInt(savedActive, 10) : 0;
	});



	useEffect(() => {
		const isApplicantPath = location.pathname === "/applicants" || location.pathname.startsWith("/viewapplicants");
		if (!isApplicantPath) {
			setActive(0);
			localStorage.setItem('active', "0");
		} else {
			const savedActive = localStorage.getItem('active');
			if (savedActive !== null) {
				setActive(parseInt(savedActive, 10));
			}
		}
	}, [location.pathname]);





	return (
		<ActiveContext.Provider value={{ active, setActive }}>
			{children}
		</ActiveContext.Provider>
	);
};
